import moment from 'moment-timezone';

// Matches PracticeIdentityProvider's "EST5EDT" fallback for practices with no geocoded
// TimeZone yet (same zone, IANA name instead of the .NET-only alias).
export const DEFAULT_TIME_ZONE = 'America/New_York';

export const resolveTimeZone = (timeZone) =>
    timeZone && moment.tz.zone(timeZone) ? timeZone : DEFAULT_TIME_ZONE;

export const timeZoneAbbr = (timeZone) =>
    moment.tz(resolveTimeZone(timeZone)).format('z');

// value is a daily "HH:mm" UTC time-of-day string (or null)
export const utcToPracticeTime = (value, timeZone, format = 'HH:mm') =>
    value
        ? moment.utc(value, 'HH:mm').tz(resolveTimeZone(timeZone)).format(format)
        : null;

export const practiceTimeToUtc = (value, timeZone) =>
    value
        ? moment.tz(value, 'HH:mm', resolveTimeZone(timeZone)).utc().format('HH:mm')
        : null;
